import React from 'react'
import classNames from 'classnames'
import styles from './CreateOAuth2AppWizard.module.scss'

const STEPS = ['App Details', 'Redirect URIs', 'Scopes'] as const

interface WizardStepperProps {
  currentStep: number
}

export const WizardStepper: React.FC<WizardStepperProps> = ({ currentStep }) => {
  return (
    <div className={styles['stepper']}>
      {STEPS.map((label, index) => {
        const isActive = index === currentStep
        const isCompleted = index < currentStep

        const circleClassName = classNames(styles['stepper-circle'], {
          [styles['active']]: isActive,
          [styles['completed']]: isCompleted,
        })

        const labelClassName = classNames(styles['stepper-label'], {
          [styles['active']]: isActive,
        })

        const lineClassName = classNames(styles['stepper-line'], {
          [styles['completed']]: index <= currentStep,
        })

        return (
          <React.Fragment key={label}>
            {index > 0 ? <div className={lineClassName} /> : null}
            <div className={styles['stepper-step']}>
              <div className={circleClassName}>{isCompleted ? <i className='bi bi-check-lg' /> : index + 1}</div>
              <span className={labelClassName}>{label}</span>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
